import { Link } from "react-router-dom";
import { Loader2, RefreshCw } from "lucide-react";

export function GoldAction({ to, href, variant = "secondary", full = false, className = "", children, ...props }) {
  const classes = `fundio-action fundio-action--${variant} ${full ? "fundio-action--full" : ""} ${className}`;
  if (to) return <Link to={to} className={classes} {...props}>{children}</Link>;
  if (href) return <a href={href} className={classes} {...props}>{children}</a>;
  return <button type="button" className={classes} {...props}>{children}</button>;
}

export function GoldLoading({ label = "Wird geladen …" }) {
  return <div className="fundio-state" role="status"><Loader2 className="animate-spin" aria-hidden="true" /><p>{label}</p></div>;
}

export function GoldError({ message, onRetry, retryLabel = "Erneut versuchen", testid }) {
  return <div className="fundio-state fundio-error" role="alert" data-testid={testid}>
    <p>{message}</p>
    <GoldAction onClick={onRetry}><RefreshCw size={18} aria-hidden="true" />{retryLabel}</GoldAction>
  </div>;
}
